import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { getPromotionItems } from "../../../actions/productActions";
import "react-input-range/lib/css/index.css";
import BreadcrumbCom from "../../BreadcrumbCom";
import ProductCardStyleOne from "../../Helpers/Cards/ProductCardStyleOne";
import DataIteration from "../../Helpers/DataIteration";
import Layout from "../../Partials/Layout";
import ProductsFilter from "./ProductsFilter";
import LoadingBox from "../../Helpers/Loaders/LoadingBox";

// ReadyGo Backpack item order
const styleNumbers = ["NB009"];

const garmentTypeMap = {
  Top: "Top",
  Pants: "Pant",
  Jacket: "Jacket",
};

const fitMap = {
  Petite: "Petite",
  Regular: "Reg",
  Short: "Short",
  Tall: "Tall",
};

const sizeMap = {
  twoXL: "2XL",
  twoXLP: "2XLP",
  twoXLT: "2XLT",
  threeXL: "3XL",
  threeXLP: "3XLP",
  threeXLT: "3XLT",
  fourXL: "4XL",
  fiveXL: "5XL",
  LG: "LG",
  LGP: "LGP",
  LGT: "LGT",
  MD: "MD",
  MDP: "MDP",
  MDT: "MDT",
  SM: "SM",
  SMP: "SMP",
  SMT: "SMT",
  XL: "XL",
  XLP: "XLP",
  XLT: "XLT",
  XS: "XS",
  XSP: "XSP",
  XST: "XST",
  XXS: "XXS",
  XXSP: "XXSP",
};

const inseamMap = {
  twofive: "25",
  twosix: "26",
  twoseven: "27",
  twoeight: "28",
  twoninedotfive: "29.5",
  threeone: "31",
  threethree: "33",
};

const colorMap = {
  BKM: "BKM",
  BLK: "BLK",
  CBL: "CBL",
  CHC: "CHC",
  HPK: "HPK",
  HTR: "HTR",
  KHI: "KHI",
  MBL: "MBL",
  NVY: "NVY",
  NYM: "NYM",
  PEW: "PEW",
  PPL: "PPL",
  RED: "RED",
  RYL: "RYL",
  TEL: "TEL",
  WHT: "WHT",
  WIN: "WIN",
};

const buildFilterURL = (filters, filterMap) => {
  return Object.entries(filterMap)
    .filter(([filterKey]) => filters[filterKey])
    .map(([, urlValue]) => urlValue)
    .join(",");
};

export default function AllProductPage() {
  const { search } = useLocation(); // search is gonna be "/Home"
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/Login"; // check if redirect url exist

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const productList = useSelector((state) => state.getPromotionItems);
  const { loading, products } = productList;

 
  const sortedProducts = products
    ? [...products].sort((a, b) => {
        const aIndex = styleNumbers.indexOf(a.styleNumber);
        const bIndex = styleNumbers.indexOf(b.styleNumber);

        return aIndex - bIndex;
      })
    : [];

  const [filters, setFilter] = useState({
    // garmentType
    Top: false,
    Pants: false,
    Jacket: false,

    // color
    BKM: false,
    BLK: false,
    CBL: false,
    CHC: false,
    HPK: false,
    HTR: false,
    KHI: false,
    MBL: false,
    NVY: false,
    NYM: false,
    PEW: false,
    PPL: false,
    RED: false,
    RYL: false,
    TEL: false,
    WHT: false,
    WIN: false,

    // fit
    Petite: false,
    Regular: false,
    Short: false,
    Tall: false,

    // size
    twoXL: false,
    twoXLP: false,
    twoXLT: false,
    threeXL: false,
    threeXLP: false,
    threeXLT: false,
    fourXL: false,
    fiveXL: false,
    LG: false,
    LGP: false,
    LGT: false,
    MD: false,
    MDP: false,
    MDT: false,
    SM: false,
    SMP: false,
    SMT: false,
    XL: false,
    XLP: false,
    XLT: false,
    XS: false,
    XSP: false,
    XST: false,
    XXS: false,
    XXSP: false,

    // Inseam
    twofive: false,
    twosix: false,
    twoseven: false,
    twoeight: false,
    twoninedotfive: false,
    threeone: false,
    threethree: false,
  });

  const [volume, setVolume] = useState({ min: 0, max: 100 });
  const [price, setPrice] = useState({ min: 0, max: 100 });
  const [storage, setStorage] = useState(null);
  const [filterToggle, setToggle] = useState(false);

  // validate logined user
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  /* single filter */
  useEffect(() => {
    if (!userInfo) {
      console.log("You need to login.");
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logined ");
    }

    const GarmentTypeURL = buildFilterURL(filters, garmentTypeMap);
    const fitURL = buildFilterURL(filters, fitMap);
    const sizeURL = buildFilterURL(filters, sizeMap);
    const inseamURL = buildFilterURL(filters, inseamMap);
    const colorURL = buildFilterURL(filters, colorMap);

    const priceFromURL =
      price.min || price.min === 0 ? price.min.toString() : "";

    const priceToURL =
      price.max || price.max === 0 ? price.max.toString() : "";

    dispatch(
      getPromotionItems({
        styleNumbers,
        GarmentType: GarmentTypeURL,
        fit: fitURL,
        size: sizeURL,
        inseam: inseamURL,
        color: colorURL,
        priceFrom: priceFromURL,
        priceTo: priceToURL,
      })
    );

  }, [dispatch, filters, price, navigate, redirect, userInfo]);

  const checkboxHandler = (e) => {
    const { name } = e.target;

    setFilter((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const volumeHandler = (e) => {
    setVolume(e);
  };

  const priceHandler = () => {
    setPrice(volume);
  };

  const filterStorage = (value) => {
    setStorage(value);
  };

  return (
    <>
      <Layout>
        <div className="products-page-wrapper w-full">
          <div className="container-x mx-auto">
            <BreadcrumbCom
              paths={[
                { name: "Home", path: "/" },
                {
                  name: "ReadyGo Insulated Lunch Bag",
                  path: "/Bags/ReadyGo_LunchBag",
                },
              ]}
            />

            {/* ReadyGo Banner */}
            <div className="breadcrumb-wrapper font-400 text-[13px] text-qblack mb-[23px]">
              <img
                src="https://maevn-images.s3.us-east-2.amazonaws.com/banners/2025-10-27/B2B_ReadyGO_Banner_2000x500.jpg"
                alt="Collection"
                style={{ width: "100%", height: "auto" }}
              />
            </div>

            <div className="w-full lg:flex lg:space-x-[30px]">
              {/* filter */}
              <div className="lg:w-[270px]">
                <ProductsFilter
                  filterToggle={filterToggle}
                  filterToggleHandler={() => setToggle(!filterToggle)}
                  filters={filters}
                  checkboxHandler={checkboxHandler}
                  volume={volume}
                  volumeHandler={volumeHandler}
                  priceHandler={priceHandler}
                  storage={storage}
                  filterstorage={filterStorage}
                  className="mb-[30px]"
                />
              </div>

              <div className="flex-1">
                <div className="products-sorting w-full bg-white md:h-[70px] flex md:flex-row flex-col md:space-y-0 space-y-5 md:justify-between md:items-center p-[30px] mb-[40px]">
                  <div>
                    <p className="font-400 text-[13px]">
                      <span className="text-qgray">Showing</span>{" "}
                      {sortedProducts && sortedProducts.length > 0
                        ? sortedProducts.length
                        : 0}{" "}
                      results
                    </p>
                  </div>

                  <button
                    onClick={() => setToggle(!filterToggle)}
                    type="button"
                    className="w-10 lg:hidden h-10 rounded flex justify-center items-center border border-qyellow text-qyellow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                      />
                    </svg>
                  </button>
                </div>

                <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5 mb-[40px]">
                  <>
                    {loading && <LoadingBox />}

                    {sortedProducts && sortedProducts.length !== 0 ? (
                      <DataIteration
                        datas={sortedProducts}
                        startLength={0}
                        endLength={sortedProducts.length}
                      >
                        {({ datas }) => (
                          <div data-aos="fade-up" key={datas.id}>
                            <ProductCardStyleOne datas={datas} />
                          </div>
                        )}
                      </DataIteration>
                    ) : (
                      // Handling for when there are no products or filtering results in an empty list
                      <DataIteration
                        datas={sortedProducts}
                        startLength={0}
                        endLength={0}
                      >
                        {/* Empty component */}
                        {({ datas }) => (
                          <div data-aos="fade-up" key={datas.id}>
                            <ProductCardStyleOne datas={datas} />
                            {/* You can insert an empty state component or message here */}
                          </div>
                        )}
                      </DataIteration>
                    )}
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}